import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Checkbox, Form, Input, notification, Switch } from 'antd';
import CommonButton, { ButtonLoader } from 'Components/CommonButton';
import CommonDiv from 'Components/CommonDiv';
import { CashFlowDropdown, PaymentCodeDropdown, ShipmentCodeDropdown } from 'Components/Dropdowns';
import { FormDivision, FormSection } from 'Components/Form';
import leadingZeroes from 'leading-zeroes';
import { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { appConstant } from 'Util/constants';
import { INSERT_BUYER, UPDATE_BUYER} from 'Util/mutations';
import {  GET_BUYER } from 'Util/queries';
import { v4 as uuidv4 } from 'uuid';
import { BuyerCardHeader } from './components/BuyerCard';
import { useRecoilState } from 'recoil';
import { vendorDetailAtom, selectedVendorAtom } from '../../../Store/crmAtom';
import { PlusOutlined } from '@ant-design/icons';
import _ from 'lodash'
import axios from 'axios';
import PhoneValidator from 'Components/PhoneValidator'
import { uploadImage } from 'Util/imageUploaderS3';
import BuyerTypeDropdown from 'Components/BuyerTypeDropdown';

const Container = styled.div``
function NewBuyerPage(props) {

    const [form] = Form.useForm();
    const params = useParams()
    const routeLocation = useLocation()
    const history = useHistory()
    const [editMode, setEditMode] = useState(routeLocation.pathname.includes('/crm/wholesale/edit'))
    const [formLoading, setFormLoading] = useState(false)
    const [vendorId, setVendorId] = useState('')
    const [disabled, setDisabled] = useState(routeLocation.pathname.includes('/crm/wholesale/edit'))
    const [img, setImg] = useState();
    const [origImg, setOrigImg] = useState(null);
    const imageRef = useRef(null)
    const onboard_code = uuidv4();
    const [disableEmail, setDisableEmail] = useState(true)

    const [vendor, setVendor] = useRecoilState(vendorDetailAtom) //TODO
    const [selectedVendor, setSelectedVendor] = useRecoilState(selectedVendorAtom);

    const [getBuyer, { loading, error, data, refetch, networkStatus }] = useLazyQuery(GET_BUYER, {
        fetchPolicy: "network-only",
        onCompleted() {
            const userDetails = data?.buyer_db?.buyer_users[0]

            setVendor(userDetails)

            form.setFieldsValue({
                ...userDetails,
            })
            setImg(userDetails.image)
            setOrigImg(userDetails.image)
            setDisableEmail(userDetails.email && userDetails.email === "")
        }
    })


    const [add, {error: addError}] = useMutation(INSERT_BUYER, {
        onCompleted(data) {
            const { returning } = data.buyer_db.insert_buyer_users
            const vid = leadingZeroes(returning[0].id, appConstant.leadingZero)
            setVendorId(vid)
            notification['success']({
                message: 'Saved!',
                description: `Buyer ${vid} has been saved!`,
            });
            setFormLoading(false);
            setEditMode(true)
            setSelectedVendor({
                id: returning[0].id,
                name: returning[0].name,
            })
            history.push(`/crm/wholesale/edit/${returning[0].user_id}`, { prevPath: '/crm/wholesale'})
            setDisabled(true)
        }
    });

    // console.log('addError', addError);
    
    const [update] = useMutation(UPDATE_BUYER, {
        onCompleted(data) {
            setVendor(data.buyer_db.update_buyer_users.returning[0])
            setFormLoading(false);
            notification['success']({
                message: 'Updated!',
                description: 'Buyer Updated!',
            });
            setDisabled(true)
        }
    });

    useEffect(() => {
        if (editMode) {
            getBuyer({ variables: { where: { id: { _eq: params.id } } }  })
            setVendorId(leadingZeroes(params.id, appConstant.leadingZero))
        } else {
            setVendor({})
        }
        return () => {
            setVendor({})
        }
    }, [])

    const submitHandler = async (values) => {
        setFormLoading(true);
        /** file  */
        // let image = origImg
        // if (!_.isUndefined(imageRef.current.files[0])) {
        //     const file = imageRef.current.files[0];
        //     let existingImageId = null;

        //     if(editMode && origImg){
        //       const parts = origImg.split('/')
        //       const lastPart = parts[parts.length - 1]
        //       existingImageId = lastPart.replace(/\.(png|jpg)$/, "")
        //     }
        //     const imageId = existingImageId ?? uuidv4()
      
        //     const postData = {
        //       filename: `${imageId}.png`,
        //       directory: 'user-profile'
        //     };
            
        //     await uploadImage(postData, file)
        //     image = `https://assets.catch-value.com/user-profile/${imageId}.png`
        //   }

        if (editMode) {
            update({
                variables: {
                    _eq: params.id,
                    _set: values
                }
            })
        }else{
            add({
                variables: {
                    objects: {   
                        ...values,
                        onboard_code                          
                    }
                }
            })
        }
    }
    

    const failedSubmitHandler = (values) => {
        setFormLoading(false);
        notification['error']({
            message: 'Something went wrong!',
            description: 'Please input values on required fields.',
        });
    }

    const headerEvents = (eventName) => {

        // switch (eventName) {
        //     case 'preapprove-reject':
        //         break;
        //     default:
        //         break;
        // }

        /** fetch vendor */
        refetch().then(res => setVendor(res.data.buyer_db.buyer_users[0]))

    }

    const cancelHandler = () => {
        history.push(`/crm/wholesale`)
    }

    const handleInputChange = async (event) => {

        const file = event.target.files[0];

        if (file && file.type.startsWith('image/')) {
            setImg(URL.createObjectURL(file))
        }
    }

    const handleEmailChange = (value) => {
        if (value === "") {
            setDisableEmail(true)
            return true
        }
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const format = regex.test(value);
        if (format){
            setDisableEmail(false)
        } else {
            setDisableEmail(true)
        } 
        return format
    }

    const checkUser = async (user) => {
        const res = await axios.post(`${process.env.REACT_APP_AUTH_ENDPOINT}/checkuser`, { user }) 
        const { exist } = res.data
        return exist
    }
      
    return (
        <Container>

            <BuyerCardHeader onEvent={headerEvents} editMode={editMode} setDisabled={(set) => setDisabled(set)} />

            <Form
                form={form}
                name='buyerForm'
                onFinish={submitHandler}
                onFinishFailed={failedSubmitHandler}
            >

                <FormSection title="General">
                    <FormDivision>
                        <Form.Item 
                            label="Buyer Type" 
                            name="buyer_type_id"
                        >
                            <BuyerTypeDropdown disabled={disabled} />
                        </Form.Item>

                        <Form.Item 
                            label="Name/Company" 
                            name="name"
                            rules={[{ required: true, message: '' }]}
                        >
                            <Input disabled={editMode} />
                        </Form.Item>

                        <Form.Item 
                            label="Registered Address 1" 
                            name="address"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>

                        <Form.Item 
                            label="Country/Region Code" 
                            name="country_code"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>

                        <Form.Item 
                            label="City" 
                            name="city"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>

                        <Form.Item 
                            label="Postal Code" 
                            name="postal"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>
                        
                        <Form.Item 
                            label="Delivery Address 1" 
                            name="delivery_address"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>

                        <Form.Item 
                            label="Country/Region Code" 
                            name="delivery_country_code"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>

                        <Form.Item 
                            label="City" 
                            name="delivery_city"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>

                        <Form.Item 
                            label="Postal Code" 
                            name="delivery_postal_code"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>
                    </FormDivision>

                    <FormDivision>

                        <Form.Item 
                            label="Phone No." 
                            name="phone"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>

                        <Form.Item label="Mobile No." name="mobile"
                            rules={[{ required: true, message: '' },
                            // {
                            //     validator: async (_, value) => {
                            //         const exists = await checkUser(value)
                            //         if (exists && value !== vendor.mobile) {
                            //             return Promise.reject(new Error('Mobile # already exists.'))
                            //         }
                            //         return Promise.resolve();
                            //     },
                            // },
                            {
                                pattern: /^\+?[1-9]\d{1,14}$/,
                                message: 'Invalid Format',
                            }
                        ]}>
                            <PhoneValidator disabled={editMode}/>
                        </Form.Item>

                        <Form.Item 
                            label="Email" 
                            name="email"
                            rules={[{ required: true, message: '' },
                                {
                                    validator: (_, value) => {
                                        const valid = handleEmailChange(value)
                                        if (valid || value === undefined || value == null) {
                                            return Promise.resolve();
                                        }else{
                                            return Promise.reject(new Error('Invalid Format'));
                                        }
                                    }
                                },
                                ]}
                        >
                            <Input disabled={disabled}/>
                        </Form.Item>

                        <Form.Item 
                            label="Company Registration" 
                            name="company_registration"
                        >
                            <Input disabled={editMode} />
                        </Form.Item>

                        <Form.Item 
                            label="Username" 
                            name="username" 
                            rules={[{ required: true, message: '' }]}
                            //TODO: rules is making the button not responsive
                            // rules={[
                            //     {
                            //         validator: async (_, value) => {
                            //             const exists = await checkUser(value)
                            //             if (exists && value !== vendor.username) {
                            //                 return Promise.reject(new Error('Username already exists.'))
                            //             }
                            //             return Promise.resolve();
                            //         }
                            //     }               
                            // ]}
                        >
                            <Input disabled={editMode} />
                        </Form.Item>

                        <Form.Item 
                            label="Contact Person" 
                            name="contact_person_name"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>

                        <Form.Item 
                            label="Contact No." 
                            name="contact_person_number"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>

                        <Form.Item 
                            label="Transaction Currency" 
                            name="transaction_currency"
                        >
                            <Input disabled={disabled} />
                        </Form.Item>
                        
                        <div style={{ display: "flex", flexDirection: "row", marginBottom: 24 }}>
                            <div style={{ marginRight: 52 }}>Verification Documents</div>
                            <div style={{ display: "flex" }}>
                                {img && <img src={img} alt="" style={{ height: 70, width: 70, marginRight: 10 }} />}
                                <label htmlFor="upload-photo" style={{ display: "flex", backgroundColor: "#D9E3F3", alignItems: "center", justifyContent: "center" }}>
                                    <PlusOutlined style={{ fontSize: 70, color: "#90ABDD" }} size={100} color="red" />
                                </label>
                                <input type="file" ref={imageRef} onChange={handleInputChange} id="upload-photo" style={{ display: "none" }} disabled={disabled} />
                            </div>
                        </div>

                    </FormDivision>
                </FormSection>

                <FormSection title="Invoicing">
                    <FormDivision>
                        <Form.Item label="GST Registration No." name="gst_registration" ><Input disabled={disabled} /></Form.Item>
                    </FormDivision>
                    <FormDivision>
                        <Form.Item label="Prices Including GST" name="gst_include" valuePropName="checked">
                            <Switch disabled={disabled} />
                        </Form.Item>
                    </FormDivision>
                </FormSection>

                <FormSection title="Payments">
                    <FormDivision>
                        <Form.Item label="VPA" name="virtual_payment_address"
                        ><Input disabled={disabled} /></Form.Item>
                        <Form.Item label="Payment Terms Code" name="payment_terms"
                        >
                            <CashFlowDropdown placeholder="Payment Terms Code" disabled={disabled} />
                        </Form.Item>
                        <Form.Item label="Payment Method Code" name="payment_code"
                        >
                            <PaymentCodeDropdown placeholder="Payment Method Code" disabled={disabled} />
                        </Form.Item>
                    </FormDivision>
                    <FormDivision>
                        <Form.Item label="Preferred Bank Account" name="prefered_bank"><Input disabled={disabled} /></Form.Item>
                        <Form.Item label="Cashflow Payment Terms" name="cash_flow_terms" >
                            <CashFlowDropdown placeholder="Select Cashflow Payment Terms" disabled={disabled} />
                        </Form.Item>
                        <Form.Item label="Creditor No." name="creditor_number" ><Input disabled={disabled} /></Form.Item>
                    </FormDivision>
                </FormSection>

                <FormSection title="Receiving">
                    <FormDivision>
                        <Form.Item label="Delivery Address" name="location_id"
                            
                        >
                            <Input disabled={disabled} />
                            {/* <LocationDropdown onChange={(lid) => { getLocation({ variables: { where: { id: { _eq: lid } } } }) }} disabled={disabled} /> */}
                        </Form.Item>
                        <Form.Item label="Shipment Method Code" name="shipment_method_code"
                           
                        >
                            <ShipmentCodeDropdown placeholder="Shipment Method Code" disabled={disabled} />
                        </Form.Item>
                        <Form.Item label="Lead Time Calculation" name="lead_time_calculation" ><Input disabled={disabled} /></Form.Item>
                    </FormDivision>
                    <FormDivision>
                        <Form.Item label="Warehouse Facility" name="location_code" ><Input readOnly disabled={disabled} /></Form.Item>

                        <Form.Item label="Coordinates" name="coordinates" ><Input readOnly disabled={disabled} /></Form.Item>
                    </FormDivision>
                </FormSection>

                <CommonDiv direction="row" justify="flex-end"  >
                    <ButtonLoader loading={formLoading} htmlType='submit' >
                        {editMode ? 'Update' : 'Save'}
                    </ButtonLoader>
                    <CommonButton className='reverse' onClick={cancelHandler} >Cancel</CommonButton>
                </CommonDiv>

            </Form>


        </Container>
    )
}

NewBuyerPage.propTypes = {}

export default NewBuyerPage
